import React, { useState } from "react";
import {
  Card,
  CardContent,
  Avatar,
  InputBase,
  Box,
  Typography,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

function ActivityList({
  activities,
  selectedActivity,
  setSelectedActivity,
  loading = false,
}) {
  const [search, setSearch] = useState("");

  const filteredActivities = activities.filter((activity) =>
    activity.name.toLowerCase().includes(search.toLowerCase())
  );

  if (loading) {
    return (
      <Card
        sx={{
          minWidth: 280,
          maxWidth: 320,
          boxShadow: 2,
          height: 600,
          borderRadius: 3,
        }}
      >
        <CardContent sx={{ p: 2 }}>
          <Typography variant="h6" fontWeight="bold" mb={1}>
            Activities
          </Typography>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="400px"
          >
            <CircularProgress />
          </Box>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card
      sx={{
        minWidth: 280,
        maxWidth: 320,
        boxShadow: 2,
        height: 600,
        borderRadius: 3,
        overflowY: "auto",
      }}
    >
      <CardContent sx={{ p: 2 }}>
        <Typography variant="h6" fontWeight="bold" mb={1}>
          Activities ({activities.length})
        </Typography>
        <InputBase
          placeholder="Search Activity"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{
            width: "100%",
            mb: 2,
            px: 1.5,
            py: 1,
            border: "1px solid #e0e0e0",
            borderRadius: 2,
            background: "#f7f7f7",
            fontSize: 14,
          }}
        />
        <Box>
          {filteredActivities.length === 0 ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="200px"
            >
              <Typography variant="body2" color="textSecondary">
                No activities found
              </Typography>
            </Box>
          ) : (
            filteredActivities.map((activity) => (
              <Box
                key={activity._id}
                onClick={() => setSelectedActivity(activity)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  p: 1.2,
                  mb: 1,
                  borderRadius: 2,
                  cursor: "pointer",
                  backgroundColor:
                    selectedActivity?._id === activity._id ? "#2d3748" : "#fff",
                  color:
                    selectedActivity?._id === activity._id ? "#fff" : "inherit",
                  transition: "background 0.2s",
                  boxShadow:
                    selectedActivity?._id === activity._id ? 2 : undefined,
                  border: "1px solid #e0e0e0",
                }}
              >
                <Avatar
                  src={activity.image}
                  alt={activity.name}
                  sx={{ width: 44, height: 44 }}
                  variant="rounded"
                />
                <Box display="flex" flexDirection="column" flex={1}>
                  <Typography
                    variant="subtitle2"
                    fontWeight="medium"
                    sx={{
                      fontSize: 14,
                      color:
                        selectedActivity?._id === activity._id
                          ? "#fff"
                          : "inherit",
                      mb: 0.5,
                    }}
                  >
                    {activity.name}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      opacity: 0.7,
                      fontSize: 11,
                      color:
                        selectedActivity?._id === activity._id
                          ? "#fff"
                          : "inherit",
                      mb: 0.5,
                    }}
                  >
                    {activity.lastMessageTime}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      opacity: 0.8,
                      fontSize: 11,
                      color:
                        selectedActivity?._id === activity._id
                          ? "#fff"
                          : "inherit",
                      mb: 0.5,
                    }}
                  >
                    {activity.lastMessage}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      opacity: 0.6,
                      fontSize: 10,
                      color:
                        selectedActivity?._id === activity._id
                          ? "#fff"
                          : "inherit",
                    }}
                  >
                    {activity.participantCount} participant
                    {activity.participantCount !== 1 ? "s" : ""}
                  </Typography>
                </Box>
              </Box>
            ))
          )}
        </Box>
      </CardContent>
    </Card>
  );
}

export default ActivityList;
